document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".newsletter-minimal");

  sections.forEach(function (section) {

    const input = section.querySelector(".newsletter-field input");
    const field = section.querySelector(".newsletter-field");
    const button = section.querySelector(".newsletter-field button");

    if (!input || !field) return;

    /* Focus Effect */

    input.addEventListener("focus", function () {
      field.classList.add("is-focused");
    });

    input.addEventListener("blur", function () {
      field.classList.remove("is-focused");
    });

    /* Enter Key */

    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        button.click();
      }
    });

  });

});